module.exports = __webpack_public_path__ + "media/LandingPageAssets/InsightsTab-8a2a1a77.png";